import io from "socket.io-client";
import config from "config";

export const NOTIFICATION_CENTER_EVENTS = "nc";
export const WEBSOCKET_EVENT_NOTIFY = "notify";

class WebSocketService {
  constructor(url) {
    this.wsUrl = url;
    this.socket = null;
    this.connected = false;
    this.initializers = [];
    this.listeners = {};
    this.senders = [];
  }

  connect() {
    if (this.wsUrl && !this.connected) {
      this.socket = io.connect(this.wsUrl);

      this.socket.on("connect", () => {
        this.connected = true;
        this.runInitializers();
        this.bindListeners();
        this.callSenders();
      });
    }
  }

  addListener(event, callback) {
    if (!this.connected) {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event].push(callback);
      return false;
    }

    this.socket.on(event, callback);
    return true;
  }

  bindListeners() {
    Object.keys(this.listeners).forEach((event) => {
      Object.values(this.listeners[event]).forEach((cb) => {
        this.socket.on(event, cb);
      });
    });
    this.listeners = {};
  }

  send(event, data = {}) {
    if (!this.connected) {
      this.senders.push({
        event,
        data,
      });
      return false;
    }

    this.socket.emit(event, data);
    return true;
  }

  callSenders() {
    Object.values(this.senders).forEach((item) => {
      this.socket.emit(item.event, item.data);
    });
    this.senders = [];
  }

  addInitializer(callback) {
    this.initializers.push(callback);
    if (this.isConnected()) {
      callback();
    }
    return this;
  }

  runInitializers() {
    this.initializers.forEach((callback) => {
      callback();
    });
  }

  isConnected() {
    return this.connected;
  }
}

const webSocketServiceInstance = new WebSocketService(config.websocketUrl);

export default webSocketServiceInstance;